import axios from 'axios'
import errorCode from './error-code.js'
import { message } from 'ant-design-vue'

const Toast = message

export default {
  async _request(url, options) {
    let baseUrl = process.env.VUE_APP_BASE_URL || ''
    if (options.skipBaseUrl) {
      baseUrl = ''
    }
    // 请求之前添加请求头
    options.headers = options.headers || {}
    const token = localStorage.getItem('token')
    const sessionKey = localStorage.getItem('x-j-c-session-key')
    if (token) {
      options.headers.Authentication = token
    }
    if (sessionKey) {
      options.headers['x-j-c-session-key'] = sessionKey
    }
    options.responseType = options.responseType || 'json'

    const { toastError = true } = options || {}
    try {
      // 发起请求
      const response = await axios({
        method: options.method,
        url: `${baseUrl + url}`,
        headers: options.headers,
        timeout: options.timeout || 60000,
        params: options.params,
        data: options.data,
        responseType: options.responseType || 'json',
      })

      // 请求后处理
      const res = response.data

      const { code, object, message, success, requestId } = res || {}
      const sessionKey = response.headers['x-j-c-session-key']
      if (sessionKey) {
        localStorage.setItem('x-j-c-session-key', sessionKey)
      }
      if (options.responseType !== 'json') {
        return response
      }
      // isResponseOrigin为true时不处理返回结果，直接返回整个response.data
      if (options.ifResponseOrigin) {
        return res
      }
      if (code === 200 || success) {
        return object
      } else if (code === 20001 || code === 20002 || code === 20006) {
        // 未登录
        Toast.error('需要重新登录')
        setTimeout(() => {
          localStorage.removeItem('token')
          window.location.href = '/v1/login'
        }, 2000)
      } else {
        const msg = `${requestId ? '[' + requestId + ']' : ''}${errorCode.getErrorMsg(code) || message}`
        toastError && Toast.error(msg)
        return Promise.reject(res)
      }
    } catch (e) {
      console.error('e', e)
      const msg = e.message
      toastError && Toast.error(msg)
      return Promise.reject(e)
    }

  },

  get(url, options = {}) {
    return this._request(
      url,
      Object.assign(options, {
        method: 'get'
      })
    )
  },

  post(url, options = {}) {
    return this._request(
      url,
      Object.assign(options, {
        method: 'post'
      })
    )
  },

  export(url, params) {
    // 如果没有域名默认配置baseURI
    if (!/https?:\/\//i.test(url)) {
      const baseUrl = process.env.VUE_APP_BASE_URL || ''
      url = baseUrl + url
    }
    const paramArr = []
    for (const key in params) {
      if (!params[key]) {
        continue
      }
      if (typeof params[key] === 'object') {
        params[key] = encodeURIComponent(JSON.stringify(params[key]))
      }
      paramArr.push(key + '=' + params[key])
    }
    const token = localStorage.getItem('token') || ''
    paramArr.push(`token=${token}`)

    if (paramArr.length !== 0) {
      if (url.indexOf('?') >= 0) {
        url += '&'
      } else {
        url += '?'
      }
      url += paramArr.join('&')
    }

    const saveLink = document.createElement('a')
    saveLink.href = url
    saveLink.target = '_blank'
    saveLink.click()
  }
}
